var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.selectedInitiative.footer))]),_c('div',{staticClass:"time-container"},[_c('span',[_vm._v(_vm._s(new Date().getHours() + ":" + new Date().getMinutes().toString().padStart(2, '0')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }